import React from 'react';
import { FormattedMessage } from 'react-intl';
import InboxTransitionBase from './InboxTransitionBase';

const InboxTransitionExpireReviewPeriod = ({ transition, buttons }) => {
  return (
    <InboxTransitionBase
      header={<FormattedMessage id="BookingStatus.bookingComplete" />}
      date={transition.createdAt}
      direction="left"
      buttons={buttons}
    />
  );
};

export default InboxTransitionExpireReviewPeriod;
